import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Play, X } from "lucide-react";

// Click-to-play only. No autoplay in-page, no YouTube iframe. Vertical 9:16.
export default function VideoLightbox({ poster, src, caption, subtitle, rotate = "-2deg", testId }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="group relative block w-full focus:outline-none focus-visible:ring-2 focus-visible:ring-[#EA7A4F]"
        style={{ transform: `rotate(${rotate})` }}
        data-testid={testId || "video-thumb"}
        aria-label={`Lire la vidéo : ${caption}`}
      >
        <div className="relative overflow-hidden rounded-xl border-8 border-white shadow-xl">
          <div className="aspect-[9/16] w-full">
            <img src={poster} alt={caption} loading="lazy" className="h-full w-full object-cover" />
          </div>
          <div className="absolute inset-0 bg-[#14283A]/25 transition-opacity duration-300 group-hover:bg-[#14283A]/10" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="grad-bar flex h-16 w-16 items-center justify-center rounded-full text-white shadow-lg transition-transform duration-300 group-hover:scale-110">
              <Play className="ml-1 h-7 w-7 fill-current" />
            </span>
          </div>
          <span className="absolute bottom-3 left-3 rounded bg-[#14283A]/80 px-2 py-1 text-xs font-semibold text-[#F6F1E8]">
            {subtitle || "0:42 · vertical"}
          </span>
        </div>
        <span className="font-marker absolute -bottom-4 right-2 rotate-3 text-lg text-[#EA7A4F]">
          {caption}
        </span>
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[10000] flex items-center justify-center bg-[#14283A]/90 p-4 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setOpen(false)}
            data-testid="video-lightbox"
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center rounded-full border border-[#F6F1E8]/40 text-[#F6F1E8] transition-colors hover:bg-[#F6F1E8]/10"
              aria-label="Fermer"
              data-testid="video-lightbox-close"
            >
              <X className="h-6 w-6" />
            </button>
            <motion.div
              className="relative aspect-[9/16] w-full max-w-[380px] overflow-hidden rounded-2xl border-4 border-[#F6F1E8] bg-black"
              initial={{ scale: 0.9, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 20 }}
              transition={{ ease: [0.16, 1, 0.3, 1], duration: 0.4 }}
              onClick={(e) => e.stopPropagation()}
            >
              <video
                src={src}
                controls
                autoPlay
                playsInline
                className="h-full w-full object-cover"
              />
              {/* subtitles incrustés (placeholder) */}
              <div className="pointer-events-none absolute bottom-6 left-0 right-0 px-4 text-center">
                <span className="rounded bg-black/60 px-2 py-1 text-sm font-bold text-white">
                  {caption}
                </span>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
